import type { ListEvaluationsRequest } from '@compass/client/types/evaluation';
import { useState } from 'react';
import { toast } from 'sonner';

import { exportQcEvaluations } from '@/services/export-qc.service';
import type { ExportFormat } from '@/types/export.types';

export const useDownloadQcEvaluations = () => {
  const [isExporting, setIsExporting] = useState(false);

  const downloadQcEvaluations = async (
    filters: Omit<ListEvaluationsRequest, 'limit' | 'start_after_id'>,
    format: ExportFormat,
    agentNameById: Map<string, string>,
    programNameById: Map<string, string>,
  ): Promise<void> => {
    if (!filters.organization_id) {
      toast.error('Organization context is required');
      return;
    }

    setIsExporting(true);
    const toastId = toast.loading(`Preparing ${format.toUpperCase()} export...`);

    try {
      await exportQcEvaluations({
        filters,
        format,
        agentNameById,
        programNameById,
        onProgress: progress => {
          toast.loading(progress.message, { id: toastId });
        },
      });

      toast.success(`QC evaluations exported as ${format.toUpperCase()}`, { id: toastId });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to export QC evaluations';
      toast.error(message, { id: toastId });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    downloadQcEvaluations,
    isExporting,
  };
};
